var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconPwd(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 17,
    viewBox: "0 0 15 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.80964 6.45332V4.8127C2.80964 2.21905 4.91547 0.11322 7.50912 0.11322C10.1028 0.11322 12.2086 2.21905 12.2086 4.8127V6.45332C13.3301 6.52843 14.2175 7.46249 14.2175 8.60291V14.7301C14.2175 15.9186 13.252 16.8841 12.0635 16.8841H2.95474C1.7662 16.8841 0.800781 15.9186 0.800781 14.7301V8.60291C0.800781 7.46249 1.68818 6.52843 2.80964 6.45332ZM10.1961 6.44895V4.8127C10.1961 3.32957 8.99224 2.12572 7.50912 2.12572C6.02599 2.12572 4.82214 3.32957 4.82214 4.8127V6.44895H10.1961Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPwd);
export default __webpack_public_path__ + "static/media/icon_pwd.05f6d7af331685b7aa3a3ab5fa435bf5.svg";
export { ForwardRef as ReactComponent };